// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../../app';
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';
import { u2f } from '../../../lib/u2f-api';
import { convertStartRegResponse,convertFinishRegRequest,convertStartAuthResponse,convertFinishAuthRequest} from '../../../lib/yubico-webauthn';

app.controller('U2fLoginController', Controller);

/** @ngInject */
function Controller($scope, $rootScope,$window, HardTokenLoginService, AuthenticationSharedService) {
    $scope.username = localStorage.getItem('username-fido-u2f');
    $scope.rememberMe = !!$scope.username;

    $scope.message = null;

    $scope.showGuide = false;
    $scope.loginU2F = u2fLoginStart;
    
    const captcha = $scope.captcha = new Captcha({
        isVisible: () => localStorage.getItem('loginAttempts') >= 3
    });
    
    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username-fido-u2f');
        }
    };

    function u2fLoginStart() {

        //console.log('u2fLoginStart');

        var data = {
            username : $scope.username,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        };

        HardTokenLoginService.save(null, data, success, error);

        function success(response) {

            if ($scope.rememberMe) {
                localStorage.setItem('username-fido-u2f', $scope.username);
            }

            console.log('HardTokenLoginService.save() done with: ', {response});

            $scope.showGuide = true;

               /* u2f.sign(response.authenticateRequests,
                function(data) {
                    console.log(data);
                    if(data.errorCode) {
                        $rootScope.show_quide = true;
                        const key = `hard_token_login.messages.error.ERROR_${data.errorCode}`;
                        $rootScope.topLevelMessage = new SpAlert('danger', key);
                        return;
                    }
                    $rootScope.show_quide = true;
                    u2fLoginFinish(data);     
                }); */
                var credOpts=convertStartAuthResponse(response);
					$window.navigator.credentials.get(credOpts).then((credentials)=>{
						var finishRegRequest=convertFinishAuthRequest(credentials,response);
						$rootScope.show_quide = true;
						u2fLoginFinish(finishRegRequest);});

            //$rootScope.topLevelMessage = new SpAlert('success', 'U2F Login started...');
        }

        function error(error) {
            $rootScope.showGuide = false;
            if (error.status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $rootScope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $rootScope.topLevelMessage = new SpAlert('danger', error.data.message);
            }
        }
    }
    
    
    function u2fLoginFinish(data) {
        
        AuthenticationSharedService.login({
            username: $scope.username,
            password: JSON.stringify(data),
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        })
        .finally(() => captcha.reset());
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-login/u2f-login.controller.js